const PENDING = 'pending';
const RESOLVED = 'resolved';
const REJECTED = 'rejected';

export default class AsyncDataHandler {
  #state = PENDING;

  #error;

  #resolve;

  #reject;

  #promise;

  hasData() {
    let result = this.#promise;

    if (!result) {
      switch (this.#state) {
      case REJECTED:
        result = Promise.reject(this.#error);
        break;
      case RESOLVED:
        result = Promise.resolve();
        break;
      default:
        result = new Promise((resolve, reject) => {
          this.#resolve = resolve;
          this.#reject = reject;
        });
        break;
      }

      this.#promise = result;
    }

    return result;
  }

  resolve() {
    this.#state = RESOLVED;

    if (this.#resolve) {
      this.#resolve();
    }
  }

  reject(error) {
    this.#state = REJECTED;
    this.#error = error;

    if (this.#reject) {
      this.#reject(error);
    }
  }
}
